enum BREAKPOINTS {
  Sm = 640,
  Md = 768,
  Lg = 1440,
  Xl = 1280,
}

export default BREAKPOINTS;
